'use strict';

require('./featureFlag');
require('theme/js/index');
